import { c as _c } from "react/compiler-runtime";
import { ComingSoonBadge } from 'shared/components/badge/coming-soon-badge';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
import type { JSX } from "react";
interface IntegrationCardProps {
  icon: JSX.Element;
  title: string;
  subTitle: string;
  isConnect?: boolean;
  isDeactivated?: boolean;
  isComingSoon?: boolean;
  onClick?: () => void;
}
export const WrapperIntegration = t0 => {
  const $ = _c(27);
  const {
    icon,
    title,
    subTitle,
    onClick,
    isConnect: t1,
    isDeactivated: t2,
    isComingSoon: t3
  } = t0;
  const isConnect = t1 === undefined ? false : t1;
  const isDeactivated = t2 === undefined ? false : t2;
  const isComingSoon = t3 === undefined ? false : t3;
  const {
    t
  } = useLocoTranslation();
  const t4 = onClick && "hover:bg-brand-primary-subtle hover:border-brand-primary cursor-pointer";
  let t5;
  if ($[0] !== t4) {
    t5 = twMerge("bg-background-secondary border-background-secondary main-transition-colors flex h-[200px] w-full flex-col justify-between rounded-md border p-5 md:h-[220px] md:w-[320px] lg:p-7", t4);
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== title) {
    t6 = <h3>{title}</h3>;
    $[2] = title;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== icon || $[5] !== t6) {
    t7 = <div className="mb-2.5 flex items-center gap-2.5 lg:mb-5">{icon}{t6}</div>;
    $[4] = icon;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== subTitle) {
    t8 = <span>{subTitle}</span>;
    $[7] = subTitle;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t7 || $[10] !== t8) {
    t9 = <div className="mb-2.5 ">{t7}{t8}</div>;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== isComingSoon) {
    t10 = isComingSoon && <div className="flex justify-center"><ComingSoonBadge /></div>;
    $[12] = isComingSoon;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== isConnect || $[15] !== t) {
    t11 = isConnect && <div className="flex justify-center"><span className="text-green border-green bg-green/10 rounded-md border px-2.5 py-1.5">{t("dashboard.user_settings.integrations_page.connected")}</span></div>;
    $[14] = isConnect;
    $[15] = t;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== isDeactivated || $[18] !== t) {
    t12 = isDeactivated && <div className="flex justify-center"><span className="text-danger border-danger bg-danger/10 rounded-md border px-2.5 py-1.5">{t("dashboard.user_settings.integrations_page.deactivated")}</span></div>;
    $[17] = isDeactivated;
    $[18] = t;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== onClick || $[21] !== t10 || $[22] !== t11 || $[23] !== t12 || $[24] !== t5 || $[25] !== t9) {
    t13 = <div className={t5} onClick={onClick}>{t9}{t10}{t11}{t12}</div>;
    $[20] = onClick;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
    $[24] = t5;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
};